export default defineNuxtPlugin({
    name: 'dn-google-tagmanager',
    parallel: true,
    setup() {
        const { public: { googleTagManagerId } } = useRuntimeConfig();
        const GTMNoScriptSrc = computed(() => `https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}`);

        useHead({
            noscript: [
                {
                    innerHTML: `<iframe src="${GTMNoScriptSrc.value}" height="0" width="0" style="display: none; visibility: hidden;" />`,
                    tagPosition: 'bodyOpen',
                }
            ],
            script: [
                {
                    innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${googleTagManagerId}');`
                }
            ]
        });
    }
});
